import { connect } from 'react-redux'
import { StyledSubHeading } from 'components/headings'
import {
  getCashFundPreferences,
  getRegistryOwnerId,
  getUserId,
} from 'registry/reducers'
import {
  saveCashFundPreferences,
  setCashFundPreferences,
} from 'registry/actions'
import LegacyCashFundPreferenceSettings from 'registry/settings-page/cash-fund-preferences/LegacyCashFundPreferenceSettings/LegacyCashFundPreferenceSettings'
import useFeatureFlag from 'shared/hooks/useFeatureFlag/useFeatureFlag'
import PaymentPreferenceSettings from 'registry/settings-page/cash-fund-preferences/PaymentPreferenceSettings/PaymentPreferenceSettings'
import PropTypes from 'prop-types'

export const CashFundPreferences = (props) => {
  const { setCashFundPreferences, preferences } = props

  const { flagValue: isPaymentPreferenceFormEnabled } = useFeatureFlag(
    '24d_ff_regex_cash_fund_upgrades_web',
    false
  )

  return (
    <>
      <StyledSubHeading>Cash Fund Preferences</StyledSubHeading>
      {isPaymentPreferenceFormEnabled ? (
        <PaymentPreferenceSettings
          preferences={preferences}
          onPreferencesSaved={setCashFundPreferences}
        />
      ) : (
        <LegacyCashFundPreferenceSettings {...props} />
      )}
    </>
  )
}

CashFundPreferences.propTypes = {
  setCashFundPreferences: PropTypes.func.isRequired,
  preferences: PropTypes.object,
  isEditable: PropTypes.bool,
}

CashFundPreferences.defaultProps = {
  preferences: undefined,
  isEditable: false,
}

const mapStateToProps = (state) => ({
  isEditable: getRegistryOwnerId(state) == getUserId(state),
  preferences: getCashFundPreferences(state),
})

const mapDispatchToProps = (dispatch) => {
  return {
    handleSubmit: (data) => dispatch(saveCashFundPreferences(data)),
    setCashFundPreferences: (data) => dispatch(setCashFundPreferences(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CashFundPreferences)
